angular.module('app')
  .filter('photoUrl', function () {
    return function (photo, id, size) {
      if (!photo || !photo.uuid) {
        return null;
      }

      if (!size) {
        return `media/users/${id}/avatar.jpg`;
      }

      if (!photo.resized) {
        return `/media/users/${id}/${photo.uuid}/${photo.name}`;
      }

      return `/media/users/${id}/${photo.uuid}/${size}.jpg`;
    };
  });
